import DounleEntryManagement from 'views/AccountsDashboard/DoubleEntryManagement';
import ProtectedRouteAccounts from './ProtectedRoutesAccounts';
import AccountsLandingPage from 'views/AccountsDashboard/AccountsLandingPage';

export const AccountsRoutes = {
    path: '',
    children: [
        {
            path: 'dashboard',
            element: <ProtectedRouteAccounts element={<AccountsLandingPage />} />
        },
        {
            path: 'manage-double-entries',
            element: <ProtectedRouteAccounts element={<DounleEntryManagement />} />
        }
    ]
};
